import axiosInstance from "./axios";
import { errorToast } from "../shared/Toast";

// Feature-scoped API module for Pickup Blocks (physical numbered pickup racks). Uses
// the shared axios instance (Bearer auth + 401 handling). Read calls return data (or a
// safe default) and toast on error; mutations return the created/updated record (or
// null) and let the caller toast success.

// GET /api/admin/pickup-blocks?branchId= -> { blocks: [...], pickupBlockSelectionRequired }
export const getBlocks = async (params = {}) => {
  try {
    const res = await axiosInstance.get("/api/admin/pickup-blocks", { params });
    if (res?.data && !res.data.isError) return res.data.data;
    errorToast(res?.data?.message ?? "Error loading pickup blocks");
    return { blocks: [], pickupBlockSelectionRequired: true };
  } catch (error) {
    errorToast(error?.message ?? "Error loading pickup blocks");
    return { blocks: [], pickupBlockSelectionRequired: true };
  }
};

export const createBlock = async (payload) => {
  try {
    const res = await axiosInstance.post("/api/admin/pickup-blocks", payload);
    if (res?.data && !res.data.isError) return res.data.data;
    errorToast(res?.data?.message ?? "Error creating pickup block");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error creating pickup block");
    return null;
  }
};

export const updateBlock = async (id, payload) => {
  try {
    const res = await axiosInstance.put(`/api/admin/pickup-blocks/${id}`, payload);
    if (res?.data && !res.data.isError) return res.data.data;
    errorToast(res?.data?.message ?? "Error updating pickup block");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error updating pickup block");
    return null;
  }
};

// Deactivates a block (blocks are never hard-deleted so order history stays intact).
export const deleteBlock = async (id) => {
  try {
    const res = await axiosInstance.delete(`/api/admin/pickup-blocks/${id}`);
    if (res?.data && !res.data.isError) return res.data.data;
    errorToast(res?.data?.message ?? "Error deactivating pickup block");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error deactivating pickup block");
    return null;
  }
};

// PUT /api/admin/pickup-blocks/branch-settings { branchId, pickupBlockSelectionRequired }
export const updateBranchBlockSettings = async (payload) => {
  try {
    const res = await axiosInstance.put("/api/admin/pickup-blocks/branch-settings", payload);
    if (res?.data && !res.data.isError) return res.data.data;
    errorToast(res?.data?.message ?? "Error updating branch settings");
    return null;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? "Error updating branch settings");
    return null;
  }
};
